<template>
  <div id="system" class="tab-pane active">
    <LogFilterBox @apply="applyFilters" @clear="clearFilters">
      <div class="form-row align-items-end">
        <div class="col-12 col-md-6">
          <label class="form-label">User</label>
          <input
            v-model.trim="filters.userInput"
            type="text"
            class="form-control"
            autocomplete="off"
            placeholder="Username or ID"
            data-test="system-log-filter-user"
          />
        </div>
        <div class="col-12 col-md-6">
          <label class="form-label">Action</label>
          <input
            v-model.trim="filters.action"
            type="text"
            class="form-control"
            autocomplete="off"
            placeholder="Action contains…"
            data-test="system-log-filter-action"
          />
        </div>
      </div>

      <div class="form-row align-items-end mt-3">
        <div class="col-12 col-md-6">
          <label class="form-label">Date from</label>
          <custom-datepicker
            :date="filters.dateFrom"
            placeholder="Date from"
            @on-date-change="changeDates('dateFrom', $event)"
          />
        </div>
        <div class="col-12 col-md-6">
          <label class="form-label">Date to</label>
          <custom-datepicker
            :date="filters.dateUntil"
            placeholder="Date to"
            @on-date-change="changeDates('dateUntil', $event)"
          />
        </div>
      </div>
    </LogFilterBox>

    <clip-loader v-if="loading" />

    <div class="table-responsive">
      <table class="table table-hover">
        <thead class="sortable-table-header">
          <tr>
            <th>Action</th>
            <th>Effected id</th>
            <th>Model type effected</th>
            <th>Causer id</th>
            <th>Causer name</th>
            <th>Extra properties</th>
            <th>Created at</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(log, index) in system.logs"
            :key="index"
            data-test="system-log-row"
          >
            <td>{{ log.description }}</td>
            <td>{{ log.subject_id }}</td>
            <td>{{ log.subject_type }}</td>
            <td>{{ log.causer_id }}</td>
            <td>{{ log.causer_name }}</td>
            <td>{{ log.properties }}</td>
            <td>{{ log.created_at }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="row-fluid float-right">
      <DerPaginate
        v-model="system.paginate.current_page"
        :page-count="system.paginate.last_page"
        :show-go="true"
        @change="getSystemResults"
      />
    </div>
  </div>
</template>

<script>
import DerPaginate from "../../../design-system/DerPaginate.vue";
import CustomDatepicker from "../../../components/Utils/Datepicker.vue";
import ClipLoader from "../../Utils/ClipLoader.vue";
import LogFilterBox from "./LogFilterBox.vue";

export default {
  components: { DerPaginate, CustomDatepicker, ClipLoader, LogFilterBox },
  data() {
    return {
      loading: false,
      filters: {
        userInput: "",
        action: "",
        dateFrom: null,
        dateUntil: null,
      },
      system: {
        paginate: { current_page: 0, total: 0, last_page: 0 },
        logs: [],
      },
    };
  },
  created() {
    this.getSystemResults(1);
  },
  methods: {
    changeDates(key, value) {
      this.filters[key] = value;
    },
    serializeDate(d) {
      if (!d) return undefined;
      if (typeof d === "string") return d;
      if (d instanceof Date && !isNaN(d.getTime()))
        return d.toISOString().slice(0, 10);
      return undefined;
    },
    applyFilters() {
      this.getSystemResults(1);
    },
    clearFilters() {
      this.filters.userInput = "";
      this.filters.action = "";
      this.filters.dateFrom = null;
      this.filters.dateUntil = null;
      this.getSystemResults(1);
    },
    getSystemResults(page = 1) {
      this.loading = true;
      const isNumeric =
        this.filters.userInput && /^\d+$/.test(this.filters.userInput);
      const params = {
        page,
        dateFrom: this.serializeDate(this.filters.dateFrom),
        dateUntil: this.serializeDate(this.filters.dateUntil),
        action: this.filters.action || undefined,
        username: !isNumeric ? this.filters.userInput || undefined : undefined,
        causer_id: isNumeric ? Number(this.filters.userInput) : undefined,
      };
      axios
        .get("/api/internal/admin/logs/system", { params })
        .then((res) => {
          const collection = res.data;
          this.system.paginate = collection.paginate;
          this.system.logs = collection.data;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.userErrorMessage(error);
        });
    },
  },
};
</script>
